// @flow
import type {
  Emit,
} from '../../core/events';
import * as r from 'ramda';

export const emit = (
  document: Document,
): Emit => (evt, payload, hookFlag) => {
  return new Promise((resolve, reject) => {
    const finalPayload = r.when(
      r.always(hookFlag),
      r.merge({
        resolve,
        reject,
      }),
    )(payload);

    const event = document.createEvent('CustomEvent');
    event.initCustomEvent(evt, false, false, finalPayload);

    document.dispatchEvent(event);

    if (!hookFlag) {
      resolve();
    }
  });
};

export default null;
